import {getLocalizedText, texts} from '../../../../constants/TextConst';
import {
    showWarnMessage,
    showUnsavedChangesMessages
} from '../../../../_shared/Messages/actions/MessageActions';
import {getCondsZoomTypes} from './Cond';
import {messagesIds} from '../../../../_shared/Messages/consts';

let deleteContainerServer;
let getContainerDataServer;
let saveContainerServer;

export function initFunctions(funcs) {
    deleteContainerServer = funcs.deleteContainer;
    getContainerDataServer = funcs.getContainerData;
    saveContainerServer = funcs.saveContainer;
}

export function deleteContainer(screen, field) {
    showUnsavedChangesMessages(getLocalizedText(texts.deleteValidationTxt), () => {
        deleteContainerServer(field.container);
        screen.collection.deleteField(field);
    });
}

export function getContainerData(field) {
    if (field.isNewContainer) {
        field.setActive(true);
    } else {
        getContainerDataServer &&
            getContainerDataServer(field.container, data => updateContainerData(field, data));
    }
}

function updateContainerData(field, data) {
    getCondsZoomTypes(data.container, condData => initContainerField(field, condData));
}

function initContainerField(field, data) {
    field.initContainerField(data);
}

export function saveContainer(container, onConfirm) {
    if (container.title === '') {
        showWarnMessage({
            id: messagesIds.screens.saveContainerNoTitleWarn,
            title: getLocalizedText(texts.nameMandatoryTxt)
        });
    } else {
        // TODO: need to handle case if save is failed - unmark isNewContainer as false
        if (
            container.parentCollection.fields.some(
                cnt => cnt.title === container.title && cnt.container !== container.container
            )
        ) {
            showWarnMessage({
                id: messagesIds.screens.saveContainerWarn,
                title: getLocalizedText(texts.duplicateContainerErr)
            });
        } else {
            container.removeAllUninitializedConds();
            saveContainerServer &&
                saveContainerServer(
                    container.container,
                    container.message,
                    container.engmessage,
                    container.title,
                    container.active,
                    container.isOrOp,
                    container.conds,
                    container
                );
            container.isNewContainer = false;
            onConfirm();
        }
    }
}
